angular.module('cian.offer.complainer', ['cian.offer.services', 'cian.ui.popup'])
  .directive('offerComplainer', ['PopupService', function(PopupService) {
    return {
      restrict: 'A',
      link: function($scope, element, attrs) {
        element.bind('click', function(e){
          PopupService.show({
            align: 'right',
            anchorElement: e.currentTarget,
            templateUrl: '/static/components/serp/src/templates/complainer.html',
            controller: 'ComplainerCtrl',
            scrollIfNotInViewport: true,
            inputs: {
              offerId: attrs.offerId
            }
          });
        });
      }
    };
  }])
.controller('ComplainerCtrl', ["$scope", "$element", "$timeout", "$parse", "close", "OfferService", "offerId", function ($scope, $element, $timeout, $parse, close, OfferService, offerId) {
  var reasonsPath = [],
      reasonsTreeModel = [],
      defaultTitle = 'Шаг 1: На что жалуетесь?';

  $scope.selectedReason = {};
  $scope.viewMode = 'sections';
  $scope.title = defaultTitle;
  $scope.isSuccess = false;
  $scope.note = '';
  $scope.isNoteInvalid = false;
  $scope.isLoading = true;

  var complainOffer = OfferService.getModel(offerId);

  OfferService
    .getComplaintReasons(complainOffer.category)
    .then(function(data) {
      var filtersIndexes = ['89_1089'];

      if (!window.__is_by_homeowner__) {
        data = data.filter(function(item) {
          return filtersIndexes.indexOf(item.id) === -1;
        });
      }

      reasonsTreeModel = data;
      $scope.items = data;
      $scope.isLoading = false;
    }, function() {
      $scope.isLoading = false;
    });

  $scope.showSection = function(item, idx) {
    var isBlockTypeTextarea = item.blockType.toLowerCase() === 'textarea',
        isBlockTypeFinish = item.blockType.toLowerCase() === 'finish';

    $scope.isNoteRequired = isBlockTypeTextarea;
    $scope.reasonNoteHint = item.hint;
    // item.isSelected = isBlockTypeTextarea;
    $timeout(function() {
      if (item.items.length > 0) {
        var title = 'Шаг ' + (reasonsPath.length + 2) + ': ' + item.title;

        $scope.title = title;
        $scope.items = item.items;
        reasonsPath.push({title: title, idx: idx});
      } else if (isBlockTypeFinish) {
        $scope.sendComplaint(item.id, item.name);
      } else if (isBlockTypeTextarea) {
        $scope.isNoteInvalid = false;
        $scope.selectedReason = item;
        _setNoteFocus();
      }
    });
  };

  $scope.showBackButton = function() {
    return reasonsPath.length > 0;
  };

  $scope.goBack = function() {
    reasonsPath.pop();
    $scope.title = reasonsPath.length?reasonsPath[reasonsPath.length - 1].title:defaultTitle;
    $scope.items = _getItemByPath(reasonsTreeModel, reasonsPath.map(function(obj) { return obj.idx; }));
    $scope.isNoteRequired = false;
    $scope.selectedReason = {};
    $scope.note = '';
  };

  $scope.toggleReason = function(reason) {
    reason.isSelected = !reason.isSelected;
  };

  $scope.areReasonsVisible = function() {
    return $scope.viewMode === 'reasons';
  };

  $scope.sendComplaint = function(reason_id, reason_name, message) {
    OfferService
      .sendComplaint(complainOffer, reason_id, reason_name, message)
      .then(function(data) {
        if (data.data.status === 'ok') {
          _showSuccess();
          window.ca && ca('event', {
            name: 'oldevent',
            category: 'Listing',
            action: 'complain',
            label: 'send',
          });
        }
      }, function() {
        Notifications.add({
            type: 'error',
            content: 'Произошла ошибка при отправке жалобы. Пожалуйста, попробуйте снова или напишите об этом в форме <a href="/contacts/" target="_blank">обратной связи</a>',
            timeout: 10000
        });
      });
  };

  $scope.sendComplaintWithNote = function() {
    var noteText = typeof $scope.selectedReason.message !== 'undefined'?$scope.selectedReason.message.replace(/\s/g, ''):'';

    if (!noteText) {
      $scope.isNoteInvalid = true;
      _setNoteFocus();
    } else {
      $scope.sendComplaint($scope.selectedReason.id, $scope.selectedReason.name, $scope.selectedReason.message);
    }
  };

  $scope.messageTextChanged = function() {
    $scope.isNoteInvalid = false;
  }

  function _setNoteFocus() {
    $timeout(function() {
      $element.find('.complainer__reasons__item__note__text').focus();
    });
  }

  function _getItemByPath(obj, path) {
    var current = obj, i;

    for (i = 0; i < path.length; ++i) {
      if (current[path[i]] == undefined) {
        return undefined;
      } else if (current[path[i]].items.length) {
        current = current[path[i]].items;
      } else current = current[path[i]];
    }
    return current;
  }


  function _getSelectedReasons() {
    var res = [];

    for (var i = 0; i < $scope.sections.length; i++) {
      for (var k = 0; k < $scope.sections[i].reasons.length; k++) {
        if ($scope.sections[i].reasons[k].isSelected) res.push($scope.sections[i].reasons[k].code);
      }
    }

    return res;
  }

  function _showSuccess(type) {
    $scope.isSuccess = true;
  }
}]);



//////////////////
// WEBPACK FOOTER
// ../components/serp/src/scripts/cian.serp.item.complainer.js
// module id = 497
// module chunks = 0